import { createSlice } from '@reduxjs/toolkit'
import { sessionApi } from 'entities/session'
import {
    LocalStorageKeys,
    SessionStorageKeys,
    useLocalStorage,
    useSessionStorage,
} from 'shared/lib'
import { userApi } from '../api/userApi'
import { type User } from './types'

interface UserState {
    user: User | null
    showImage: boolean
}

const initialState: UserState = {
    user: null,
    showImage: true,
}

const { setItem } = useSessionStorage()
const { getItem, setItem: setLocalStorage } = useLocalStorage()

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers: (build) => {
        build.addMatcher(
            sessionApi.endpoints.login.matchFulfilled,
            (state, { payload }) => {
                state.user = (payload.user as unknown as User) || null

                setItem(
                    SessionStorageKeys.ACCESS_TOKEN,
                    payload?.tokens.accessToken
                )
                setItem(SessionStorageKeys.USER, payload.user)
                setItem(
                    SessionStorageKeys.REFRESH_TOKEN,
                    payload?.tokens.refreshToken
                )
                setLocalStorage(LocalStorageKeys.SHOW_PROFILE_PICTURE, true)
                setItem(SessionStorageKeys.USER, payload?.user)
            }
        )
        build.addMatcher(
            userApi.endpoints.getUser.matchFulfilled,
            (state, { payload }) => {
                state.user = payload || null

                const localStorage = getItem(LocalStorageKeys.USER)

                if (localStorage) {
                    setLocalStorage(LocalStorageKeys.USER, payload)
                }
                setItem(SessionStorageKeys.USER, payload)
            }
        )
    },
})
export const userReducer = userSlice.reducer
